import styled from 'styled-components'
import Modal from 'components/lib/modals/Modal'
import {
  Title as DSTitle,
  tokens,
  Column as ColumnDS
} from '@arvoreeducacao/bonsai-ds'
import { Column } from 'components/lib/flexboxgrid'

export const Title = styled.h2`
  margin: 0;
  padding: 0;
`

export const ModalStyled = styled(Modal)`
  width: 90%;
  max-width: 404px;
  border-radius: ${tokens.radius.large};
`

export const ColumnStyled = styled(Column)`
  display: flex;
  flex-direction: column;
  align-items: center;
  max-width: 292px;
  text-align: center;
  margin: 8px auto;
`

export const ColumnForm = styled(ColumnDS)`
  max-width: 328px;
  margin: 0 auto 25px auto;
`

export const Container = styled.div`
  margin: 12px;
`

export const StepOne = styled.div`
  display: ${({ step }) => (step == 'step-one' ? 'block' : 'none')};
`

export const StepTwo = styled.div`
  display: ${({ step }) => (step == 'step-two' ? 'block' : 'none')};
`

export const Text = styled.p`
  font-size: ${tokens.sizes.text}px;
  line-height: 28px;
  color: ${tokens.colors.black5};
  margin: 8px 0 24px 0;
`

export const TitleStyled = styled(DSTitle)`
  text-align: center;
  font-size: ${tokens.sizes.h[5].tablet};
  line-height: 30px;
  color: ${tokens.colors.black6};
  margin: 0;
`

export const IconCircle = styled.div`
  width: 85px;
  height: 85px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: ${tokens.colors.purple1};
  margin-bottom: 32px;
`

export const ButtonContainer = styled.div`
  width: 100%;
  display: flex;
  justify-content: ${({ justify }) => (justify ? justify : 'space-around')};
  margin-bottom: 8px;
`
